// src/utils/taxPartsOnSave.js — taxlines2-3e0b16a4 (tax codes on every line, Stage S2)
//
// WHY: the server stores each tax part (`taxParts`, plus `totalsEngineVersion`) on invoices and
// estimates it totals with the shared engine. The website's older editors (InvoiceFormModal,
// QuoteFormModal, the full-page estimate editor) still work tax out their own way, so after one of
// them re-totals a document its stored parts no longer describe its tax. Customer outputs already
// refuse parts that don't add up (lineTax.customerTaxRows); this removes them at the source.
//
// RULE: an EDIT save that re-totals tax removes the stored parts. A CREATE never touches them
// (deleteField is illegal in a plain create, and a new document has none). A save that writes the
// stored money back unchanged (the paid-invoice money lock) keeps them — its tax wasn't re-totalled.
// The approval's parts (`approvedTaxParts`) are server-owned and never sent by an editor at all.
// Until the editors move onto the engine (S4/S5), when they will write fresh parts instead.

// taxexempt3-8c4f2a1d (S3) — and what the server applied: the exemption stamp (its $0.00 rows went with
// taxParts) and the "tax couldn't be checked" mark (the person saving has now re-totalled the tax).
// The switch-off itself (taxExemptionOff) is kept: it is a staff decision, not a figure.
export const RETOTAL_DROPS = Object.freeze(['taxParts', 'totalsEngineVersion', 'taxExemptionApplied', 'taxCheckNeeded']);
export const APPROVAL_PART_FIELDS = Object.freeze(['approvedTaxParts', 'approvedTotalsEngineVersion']);

/**
 * Adds `<field>: deleteValue` for each RETOTAL_DROPS field to `write` (mutates and returns it) when
 * the save is an edit that re-totals tax. deleteValue = Firestore's deleteField().
 */
export function dropStaleTaxParts(write, { isEdit, retotals, deleteValue }) {
    if (!write || !isEdit || !retotals) return write;
    RETOTAL_DROPS.forEach((k) => { write[k] = deleteValue; });
    return write;
}
